import type { FieldValues } from "react-hook-form";
import Notify from "#components/Notify.tsx";
import { AlertAccent } from "#components/theme.ts";

export default function FormError<_T extends FieldValues>({
	error,
	className,
}: {
	error?: string;
	className?: string;
}) {
	if (!error) return null;

	return (
		<Notify accent={AlertAccent.Danger} className={className}>
			<strong>Error:</strong> {error}
		</Notify>
	);
}
